// extracted by mini-css-extract-plugin
export default {"title":"Bonuses_title__N1IQk","cardImgTop":"Bonuses_cardImgTop__dlUPU"};